module.exports = __webpack_public_path__ + "img/icon_map_gwsh_c.a7097ac0.png";